// extracted by mini-css-extract-plugin
export default {"form":"ForgotPassword_form__aGW-x","container":"ForgotPassword_container__uozXs","spinnerContainer":"ForgotPassword_spinnerContainer__Ilh12"};